/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconCalendarEvent from 'DesignSystem/Svgs/TysiaIconCalendarEvent/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CheckInAction/Confirmation/Content/CheckInCriteria/Content/TooLate/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
let constantData = 'Patient is'
let checkInAppointmentBookingStartTimeValueData = fromData.useDataFormat({ viewPath,
context: 'check_in',
path: 'appointment_booking.start_time',
format: fromHelpers.getDifferenceInMinutes,
})
let constantData1 = 'minutes late.'
let aggregateData = fromAggregate.join(constantData, checkInAppointmentBookingStartTimeValueData, constantData1)
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconCalendarEvent
  viewPath={`${viewPath}/TysiaIconCalendarEvent`}
 fill={dtColorsRed600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Patient is'"
 data="check_in.appointment_booking.start_time"
 format="helpers.js getDifferenceInMinutes"
 data="'minutes late.'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}